/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
//= require_tree ./buttons

var CollapsibleBehavior = (function() {
  let apply = undefined;
  CollapsibleBehavior = class CollapsibleBehavior {
    static initClass() {
  
      apply = function(e) {
        if (e == null) { e = {}; }
        const el = $(e.currentTarget);
        const replace_text = el.data('replace-with');
  
        if (el.text() === replace_text) {
          return el.text(el.data('replaced-text'));
        } else {
          el.data('replaced-text', el.text());
          return el.text(replace_text);
        }
      };
    }
    constructor() {
      new ExpandAllButton();
      new CollapseAllButton();

      // Prevent default events, so we don't get a page jump
      $(document).on('click', '[data-toggle=collapse]', function(e) {
        e.preventDefault();
        // Specific to expanding response text
        return $($(this).data('wrapper')).find('.response-wrap').toggleClass('truncate');
      });

      $(document).on('click', '[data-toggle="collapse"][data-replace-with]', e => apply(e));
    }
  };
  CollapsibleBehavior.initClass();
  return CollapsibleBehavior;
})();

global.CollapsibleBehavior = CollapsibleBehavior;

export default CollapsibleBehavior;